import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Section from '../../components/Section';
import Tabs from '../../components/Tabs';
import SelectedPlants from './Selection/SelectedPlants';
import { componentsEnum } from '../../utils/types';
import { selectPresentAccordingToUserIds } from '../../ducks/plants';
import SelectPlants from './Selection/SelectPlants';

const Selection = (props) => {
  const history = useHistory();

  const selectedPlantIds = useSelector(selectPresentAccordingToUserIds);

  return (
    <Section
      noCentering
      previousNav={{
        disabled: false,
        handleClick: () => history.push(
          componentsEnum.properties[componentsEnum.plantSelectionMethod].route,
        ),
      }}
      nextNav={{
        disabled: false,
        handleClick: () => history.push(
          componentsEnum.properties[componentsEnum.floweringArch].route,
        ),
      }}
      nextNavSticky
      {...props}
    >
      <Row className="justify-content-md-center">
        <Col className="text-center" md={10}>
          <h2>Huidige beplanting</h2>
          <p>
            De onderstaande plantensoorten zijn automatisch berekend door de modellen en geven de
            mogelijk al voorkomende, relevante planten aan in jouw gebied voor jouw geselecteerde
            bijen. Je kunt ervoor kiezen alle planten te selecteren, of hieruit een losse selectie
            maken als je zeker weet dat ze nu in het gebied voorkomen.
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <Tabs
            tabs={[
              {
                name: 'Beplanting toevoegen',
                pane: (<SelectPlants />),
                key: 'add',
              },
              {
                name: `Geselecteerde beplanting (${selectedPlantIds.length})`,
                pane: (<SelectedPlants />),
                key: 'remove',
              },
            ]}
          />
        </Col>
      </Row>
    </Section>
  );
};

export default Selection;
